import axios from "./axios";

const register = (credentials) => {
    return axios.post('/user/register', credentials)
}

const registration = (credentials) => {
    return axios.post('/user/registration', credentials)
}

const profile = () => {
    return axios.get('/user/profile')
}

const show = id => {
    return axios.get(`/user/show/${id}`)
        .then(response => response.data)
}

const personEdit = (id, inputForm) => {
    return axios.post(`/user/person/edit/${id}`, inputForm)
        .then(response => response.data)
}

const organizationEdit = (id, inputForm) => {
    return axios.post(`/user/organization/edit/${id}`, inputForm)
        .then(response => response.data)
}

const individualEnterpriseEdit = (id, inputForm) => {
    return axios.post(`/user/individual-enterprise/edit/${id}`, inputForm)
        .then(response => response.data)
}

const updatePerson = (profileId, personId, form) => {
    return axios.post(`/applicant/profile/${profileId}/persons/${personId}/edit`, form)
        .then(response => response.data)
}

const storePerson = (profileId, form) => {
    return axios.post(`/applicant/profile/${profileId}/persons/create`, form)
        .then(response => response.data)
}

const storePersonDocument = (profileId, form) => {
    return axios.post(`/applicant/profile/${profileId}/person-document/add`, form)
        .then(response => response.data)
}

const updatePersonDocument = (profileId, personDocumentId, form) => {
    return axios.post(`/applicant/profile/${profileId}/person-document/${personDocumentId}/edit`, form)
        .then(response => response.data)
}

const storeBankDetail = (profileId, form) => {
    return axios.post(`/applicant/profile/${profileId}/bank-detail/add`, form)
        .then(response => response.data)
}

const updateBankDetail = (profileId, bankDetailId, form) => {
    return axios.post(`/applicant/profile/${profileId}/bank-detail/${bankDetailId}/edit`, form)
        .then(response => response.data)
}

const storeContactDetail = (profileId, form) => {
    return axios.post(`/applicant/profile/${profileId}/contact-detail/add`, form)
        .then(response => response.data)
}

const updateContactDetail = (profileId, contactDetailId, form) => {
    return axios.post(`/applicant/profile/${profileId}/contact-detail/${contactDetailId}/edit`, form)
        .then(response => response.data)
}

const updateOrganization = (profileId, organizationId, form) => {
    return axios.post(`/applicant/profile/${profileId}/organization/${organizationId}/edit`, form)
        .then(response => response.data)
}

const storeOrganization = (profileId, form) => {
    return axios.post(`/applicant/profile/${profileId}/organization/create`, form)
        .then(response => response.data)
}

const updateIndividualEnterprise = (profileId, individualEnterpriseId, form) => {
    return axios.post(`/applicant/profile/${profileId}/individual-enterprise/${individualEnterpriseId}/edit`, form)
        .then(response => response.data)
}

const storeIndividualEnterprise = (profileId, form) => {
    return axios.post(`/applicant/profile/${profileId}/individual-enterprise/create`, form)
        .then(response => response.data)
}

export default {
    register,
    registration,
    show,
    profile,

    personEdit,
    organizationEdit,
    individualEnterpriseEdit,

    updatePerson,
    storePerson,
    storePersonDocument,
    updatePersonDocument,
    storeBankDetail,
    updateBankDetail,
    storeContactDetail,
    updateContactDetail,
    updateOrganization,
    storeOrganization,
    updateIndividualEnterprise,
    storeIndividualEnterprise,
}
